"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameModuleBase = void 0;
var analytics_1 = require("@dp-instant/analytics");
var audio_1 = require("@dp-instant/audio");
var core_1 = require("@dp-instant/core");
var gameflow_1 = require("@dp-instant/gameflow");
var social_1 = require("@dp-instant/social");
var inversify_1 = require("inversify");
var SetupSentryAction_1 = require("./actions/SetupSentryAction");
var DebugModule_1 = require("./debug/DebugModule");
exports.GameModuleBase = new inversify_1.ContainerModule(function () {
    core_1.di.load(core_1.CoreModule, social_1.AppModule, audio_1.AudioModule, analytics_1.AnalyticsModule, gameflow_1.GameFlowModule);
    core_1.di.bind("sentryAction").to(SetupSentryAction_1.SetupSentryAction);
    if (process.env.NODE_ENV === "development") {
        core_1.di.load(DebugModule_1.DebugModule);
    }
    core_1.di.bind("template.action").toConstantValue(new core_1.LazyAction(function () {
        var _a, _b;
        (_a = (0, core_1.lazyGet)("sentryAction")) === null || _a === void 0 ? void 0 : _a.run();
        (_b = (0, core_1.lazyGet)("fspMeterAction")) === null || _b === void 0 ? void 0 : _b.run();
    }));
});
//# sourceMappingURL=GameModuleBase.js.map